import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Intro({ customer }) {
	const { t } = useTranslation();
	return <div className="text-center text-gold p-4">
		<img alt="PTMD" src="https://api.ptmd.nl/rest/images/v1/original/logo/logo" className="d-block mx-auto col-md-3 col-lg-2 mb-4" />
		<h1>PTMD Click and Collect Catalog</h1>
		<p>{t('yourShop', { customer })}</p>
	</div>;
}
